import { render } from "./product-badge.vue?vue&type=template&id=1eff34d6"
import script from "./product-badge.vue?vue&type=script&lang=js"
export * from "./product-badge.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__